import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "my-pages-order-history" }
const _hoisted_2 = { class: "my-pages-order-history__header-container" }
const _hoisted_3 = { class: "my-pages-order-history__header" }
const _hoisted_4 = { class: "my-pages-order-history__main-container" }
const _hoisted_5 = { class: "my-pages-order-history__order-container" }
const _hoisted_6 = { class: "my-pages-order-history__order-head my-pages-order-history__order-head--mobile" }
const _hoisted_7 = { class: "my-pages-order-history__order-column" }
const _hoisted_8 = { class: "my-pages-order-history__order-column" }
const _hoisted_9 = { class: "my-pages-order-history__order-column" }
const _hoisted_10 = { class: "my-pages-order-history__order-head my-pages-order-history__order-head--desktop" }
const _hoisted_11 = { class: "my-pages-order-history__order-column" }
const _hoisted_12 = { class: "my-pages-order-history__order-column" }
const _hoisted_13 = { class: "my-pages-order-history__order-column" }
const _hoisted_14 = { class: "my-pages-order-history__mobile-table-row" }
const _hoisted_15 = { class: "my-pages-order-history__mobile-table-key" }
const _hoisted_16 = { class: "my-pages-order-history__mobile-table-value" }
const _hoisted_17 = { class: "my-pages-order-history__mobile-table-row" }
const _hoisted_18 = { class: "my-pages-order-history__mobile-table-key" }
const _hoisted_19 = { class: "my-pages-order-history__mobile-table-value" }
const _hoisted_20 = { class: "my-pages-order-history__mobile-table-row" }
const _hoisted_21 = { class: "my-pages-order-history__mobile-table-key" }
const _hoisted_22 = { class: "my-pages-order-history__mobile-table-value" }
const _hoisted_23 = { class: "my-pages-order-history__mobile-table-row" }
const _hoisted_24 = { class: "my-pages-order-history__mobile-table-key" }
const _hoisted_25 = { class: "my-pages-order-history__mobile-table-value" }
const _hoisted_26 = { class: "my-pages-order-history__mobile-table-row" }
const _hoisted_27 = { class: "my-pages-order-history__mobile-table-key" }
const _hoisted_28 = { class: "my-pages-order-history__mobile-table-value" }
const _hoisted_29 = { class: "my-pages-order-history__mobile-table-row" }
const _hoisted_30 = { class: "my-pages-order-history__mobile-table-key" }
const _hoisted_31 = { class: "my-pages-order-history__mobile-table-value" }
const _hoisted_32 = { class: "my-pages-order-history__mobile-table-row" }
const _hoisted_33 = { class: "my-pages-order-history__mobile-table-key" }
const _hoisted_34 = { class: "my-pages-order-history__mobile-table-value" }
const _hoisted_35 = { class: "my-pages-order-history__mobile-table-button" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "my-pages-order-history__table" }
const _hoisted_38 = { class: "my-pages-order-history__table-head" }
const _hoisted_39 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--orderno" }
const _hoisted_40 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--description" }
const _hoisted_41 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--status" }
const _hoisted_42 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--quantity" }
const _hoisted_43 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--unit-of-measurement" }
const _hoisted_44 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--sale-price" }
const _hoisted_45 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--total-price" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "my-pages-order-history__table-column my-pages-order-history__table-column--button" }, null, -1)
const _hoisted_47 = { class: "my-pages-order-history__table-body" }
const _hoisted_48 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--orderno" }
const _hoisted_49 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--description" }
const _hoisted_50 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--status" }
const _hoisted_51 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--quantity" }
const _hoisted_52 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--unit-of-measurement" }
const _hoisted_53 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--sale-price" }
const _hoisted_54 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--total-price" }
const _hoisted_55 = { class: "my-pages-order-history__table-column my-pages-order-history__table-column--button" }
const _hoisted_56 = ["href"]
const _hoisted_57 = { key: 1 }

import TressNavigationPills from "@/components/TressNavigationPills.vue";
import dictionary from "@/i18n/dictionary.json";
import { onMounted, PropType, ref } from "vue";
import { ILiveLink } from "@/models/ILiveLink";
import TressAccordionNoIcon from "@/components/TressAccordionNoIcon.vue";
import IconChevronDown from "@/components/icons/IconChevronDown.vue";
import { useAsyncSpinner } from "@/services/Spinner";
import { MemberApi } from "@/services/Api";
import { IOrderHistoryHeader, OrderHistoryType } from "@/models/IOrderHistoryHeader";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressTheMyPagesOrderHistory',
  props: {
  links: {
    type: Array as PropType<Array<ILiveLink>>,
    required: true,
  },
},
  setup(__props) {

const loading = ref<boolean>(true);


const orderHistoryHeaders = ref<IOrderHistoryHeader[]>();
onMounted(async () => {
  await useAsyncSpinner(async () => {
    orderHistoryHeaders.value = await MemberApi.getOrderHistory();
    loading.value = false;
  });
});
const getOrderHistoryLines = async (order: IOrderHistoryHeader, id: string, type: OrderHistoryType) => {
  await useAsyncSpinner(async () => {
    order.items = await MemberApi.getOrderHistoryLines(id, type);
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.header)), 1),
      _createVNode(TressNavigationPills, { links: __props.links }, null, 8, ["links"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (orderHistoryHeaders.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(orderHistoryHeaders.value, (order) => {
              return (_openBlock(), _createElementBlock("div", {
                key: order.id,
                class: _normalizeClass([{ 'my-pages-order-history__order-row--active': false }, "my-pages-order-history__order-row"])
              }, [
                _createVNode(TressAccordionNoIcon, {
                  "pre-header-click-on-open-function": async () => await getOrderHistoryLines(order, order.id, order.type)
                }, {
                  header: _withCtx(({ accordionClass, isOpenInternal }) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.orderno)) + ": " + _toDisplayString(order.orderNumber), 1),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.date)) + ": " + _toDisplayString(order.orderDate), 1),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.orderStatus)) + ": " + _toDisplayString(order.orderStatus), 1)
                      ]),
                      _createVNode(IconChevronDown, {
                        class: _normalizeClass(['accordion__icon', accordionClass, { 'accordion__icon--open': isOpenInternal }])
                      }, null, 8, ["class"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.orderno)) + ": " + _toDisplayString(order.orderNumber), 1),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.date)) + ": " + _toDisplayString(order.orderDate), 1),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.status)) + ": " + _toDisplayString(order.orderStatus), 1),
                      _createVNode(IconChevronDown, {
                        class: _normalizeClass(['accordion__icon', accordionClass, { 'accordion__icon--open': isOpenInternal }])
                      }, null, 8, ["class"])
                    ])
                  ]),
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.items, (row) => {
                      return (_openBlock(), _createElementBlock("dl", {
                        key: row.partNo,
                        class: "my-pages-order-history__mobile-table"
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("dt", _hoisted_15, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.partNo)), 1),
                          _createElementVNode("dd", _hoisted_16, _toDisplayString(row.partNo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("dt", _hoisted_18, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.name)), 1),
                          _createElementVNode("dd", _hoisted_19, _toDisplayString(row.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("dt", _hoisted_21, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.status)), 1),
                          _createElementVNode("dd", _hoisted_22, _toDisplayString(row.status), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("dt", _hoisted_24, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.quantity)), 1),
                          _createElementVNode("dd", _hoisted_25, _toDisplayString(row.quantity), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("dt", _hoisted_27, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.unitOfMeasurement)), 1),
                          _createElementVNode("dd", _hoisted_28, _toDisplayString(row.uom), 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("dt", _hoisted_30, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.price)), 1),
                          _createElementVNode("dd", _hoisted_31, _toDisplayString(row.price), 1)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("dt", _hoisted_33, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.total)), 1),
                          _createElementVNode("dd", _hoisted_34, _toDisplayString(row.total), 1)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          (row.url)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: row.url,
                                class: "my-pages-order-history__button"
                              }, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.reorder)), 9, _hoisted_36))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.partNo)), 1),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.name)), 1),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.status)), 1),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.quantity)), 1),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.unitOfMeasurement)), 1),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.price)), 1),
                        _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.total)), 1),
                        _hoisted_46
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.items, (row) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: row.partNo,
                            class: "my-pages-order-history__table-row"
                          }, [
                            _createElementVNode("div", _hoisted_48, _toDisplayString(row.partNo), 1),
                            _createElementVNode("div", _hoisted_49, _toDisplayString(row.name), 1),
                            _createElementVNode("div", _hoisted_50, _toDisplayString(row.status), 1),
                            _createElementVNode("div", _hoisted_51, _toDisplayString(row.quantity), 1),
                            _createElementVNode("div", _hoisted_52, _toDisplayString(row.uom), 1),
                            _createElementVNode("div", _hoisted_53, _toDisplayString(row.price), 1),
                            _createElementVNode("div", _hoisted_54, _toDisplayString(row.total), 1),
                            _createElementVNode("div", _hoisted_55, [
                              (row.url)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: row.url,
                                    class: "my-pages-order-history__button"
                                  }, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.reorder)), 9, _hoisted_56))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["pre-header-click-on-open-function"])
              ]))
            }), 128))
          : _createCommentVNode("", true),
        (orderHistoryHeaders.value?.length == 0 && !loading.value)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_57, _toDisplayString(_ctx.$t(_unref(dictionary).orderHistory.noOrdersFound)), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})